import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';

import { BreakpointTrackerContext } from '@jutro/layout';
import messages from './SgRenewalSptUpgradeTable.messages';

function SgRenewalSptUpgradeTable() {
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'phoneWide' || breakpoint === 'phone';

    return (
        <>
            {!isMobile
                && (
                    <table className="sgCoverComparisonTable">
                        <thead>
                            <tr>
                                <th width="60%">{translator(messages.CoverAndBenefits)}</th>
                                <th width="20%">
                                    {translator(messages.SagaStandard)}
                                    <br />
                                    {translator(messages.ExistingCover)}
                                </th>
                                <th width="20%">{translator(messages.SagaPlus)}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.CancellationCover)}</strong>
                                    {translator(messages.CancellationCoverText)}
                                </td>
                                <td><strong>{translator(messages.CancellationCoverStandard)}</strong></td>
                                <td><strong>{translator(messages.CancellationCoverPlus)}</strong></td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>{translator(messages.MedicalExpenses)}</strong>
                                    {translator(messages.MedicalExpensesText)}
                                </td>
                                <td><strong>{translator(messages.MedicalExpensesStandard)}</strong></td>
                                <td><strong>{translator(messages.MedicalExpensesPlus)}</strong></td>
                            </tr>

                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.LostBaggage)}</strong>
                                    {translator(messages.LostBaggageText)}
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.LostBaggageStandard1)}
                                        <p>{translator(messages.LostBaggageStandard2)}</p>
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.LostBaggagePlus1)}
                                        <p>{translator(messages.LostBaggagePlus2)}</p>
                                    </strong>
                                </td>
                            </tr>

                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.DelayedDeparture)}</strong>
                                    {translator(messages.DelayedDepartureText)}
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedDepartureStandard1)}
                                        <p>{translator(messages.DelayedDepartureStandard2)}</p>
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedDeparturePlus1)}
                                        <p>{translator(messages.DelayedDeparturePlus2)}</p>
                                    </strong>
                                </td>
                            </tr>

                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.DelayedAssistance)}</strong>
                                    {translator(messages.DelayedAssistanceText)}
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedAssistanceStandard)}
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedAssistancePlus)}
                                    </strong>
                                </td>
                            </tr>

                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.EnforcedStay)}</strong>
                                    {translator(messages.EnforcedStayText)}
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.EnforcedStayStandard1)}
                                        <p>{translator(messages.EnforcedStayStandard2)}</p>
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.EnforcedStayPlus1)}
                                        <p>{translator(messages.EnforcedStayPlus2)}</p>
                                    </strong>
                                </td>
                            </tr>

                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.MissedDeparture)}</strong>
                                    {translator(messages.MissedDepartureText)}
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.MissedDepartureStandard)}
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.MissedDeparturePlus)}
                                    </strong>
                                </td>
                            </tr>

                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.MissedPort)}</strong>
                                    {translator(messages.MissedPortText)}
                                </td>
                                <td>
                                    <div className="cross"><span>{translator(messages.No)}</span></div>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.MissedPortPlus1)}
                                        <p>{translator(messages.MissedPortPlus2)}</p>
                                    </strong>
                                </td>
                            </tr>

                            <tr>
                                <td className="text-content">
                                    <strong>{translator(messages.CruiseRejoin)}</strong>
                                    {translator(messages.CruiseRejoinText)}
                                </td>
                                <td>
                                    <div className="cross"><span>{translator(messages.No)}</span></div>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.CruiseRejoinPlus)}
                                    </strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )
            }
            {isMobile
                && (
                    <table className="sgCoverComparisonTable sgCoverComparisonTableMobile">
                        <thead>
                            <tr>
                                <th width="50%">
                                    {translator(messages.SagaStandard)}
                                    <br />
                                    {translator(messages.ExistingCover)}
                                </th>
                                <th width="50%">{translator(messages.SagaPlus)}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.CancellationCover)}</strong>
                                    {translator(messages.CancellationCoverText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>
                                        {translator(messages.CancellationCoverStandard)}
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.CancellationCoverPlus)}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.MedicalExpenses)}</strong>
                                    {translator(messages.MedicalExpensesText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>
                                        {translator(messages.MedicalExpensesStandard)}
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.MedicalExpensesPlus)}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.LostBaggage)}</strong>
                                    {translator(messages.LostBaggageText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>
                                        {translator(messages.LostBaggageStandard1)}
                                        <p>{translator(messages.LostBaggageStandard2)}</p>
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.LostBaggagePlus1)}
                                        <p>{translator(messages.LostBaggagePlus2)}</p>
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.DelayedDeparture)}</strong>
                                    {translator(messages.DelayedDepartureText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedDepartureStandard1)}
                                        <p>{translator(messages.DelayedDepartureStandard2)}</p>
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedDeparturePlus1)}
                                        <p>{translator(messages.DelayedDeparturePlus2)}</p>
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.DelayedAssistance)}</strong>
                                    {translator(messages.DelayedAssistanceText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedAssistanceStandard)}
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.DelayedAssistancePlus)}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.EnforcedStay)}</strong>
                                    {translator(messages.EnforcedStayText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>
                                        {translator(messages.EnforcedStayStandard1)}
                                        <p>{translator(messages.EnforcedStayStandard2)}</p>
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.EnforcedStayPlus1)}
                                        <p>{translator(messages.EnforcedStayPlus2)}</p>
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.MissedDeparture)}</strong>
                                    {translator(messages.MissedDepartureText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>
                                        {translator(messages.MissedDepartureStandard)}
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.MissedDeparturePlus)}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.MissedPort)}</strong>
                                    {translator(messages.MissedPortText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="cross"><span>{translator(messages.No)}</span></div>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.MissedPortPlus1)}
                                        <p>{translator(messages.MissedPortPlus2)}</p>
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                    <strong>{translator(messages.CruiseRejoin)}</strong>
                                    {translator(messages.CruiseRejoinText)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="cross"><span>{translator(messages.No)}</span></div>
                                </td>
                                <td>
                                    <strong>
                                        {translator(messages.CruiseRejoinPlus)}
                                    </strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )
            }
        </>
    );
}

export default SgRenewalSptUpgradeTable;
